import React, { useContext, useState } from 'react';
import styled from 'styled-components';
import { SettingsContext } from "../../SettingsContext";
import { StrategyValue } from "../../../models/global/DataModels/Campaign/Promotion/Strategy";
import {
    StyledSelect,
    StyledLabel,
    StyledInput,
    StyledCheckbox,
    FormGroup
} from '../../../shared/layout/forms/FormElements';

import ItemCard from '../../../shared/layout/cards/ItemCard';

const StrategyComponent = ({ strategy, index, onDelete }) => {
    const { siteSettings } = useContext(SettingsContext);
    const strategyTypes = siteSettings?.getStrategyTypes() || [];
    const [, forceUpdate] = useState(0);

    const selectedType = strategy.strategyTypeId
        ? strategyTypes.find(type => type.id === strategy.strategyTypeId)
        : null;

    const selectedAttributeId = strategy.values?.[0]?.attributeId || '';
    const selectedAttribute = selectedType?.attributes?.find(attr => attr.id === selectedAttributeId);

    const handleTypeChange = (event) => {
        const newTypeId = event.target.value;
        strategy.strategyTypeId = newTypeId;
        strategy.values = [];
        forceUpdate(prev => prev + 1);
    };

    const handleAttributeChange = (event) => {
        const newAttributeId = event.target.value;

        const selectedAttr = selectedType?.attributes?.find(attr => attr.id === newAttributeId);
        const newValue = selectedAttr?.dataType === 'boolean' ? 'true' : '';

        strategy.values = [
            new StrategyValue({
                id: null,
                promotionStrategyId: strategy.id,
                attributeId: newAttributeId,
                value: newValue,
            }),
        ];
        forceUpdate(prev => prev + 1);
    };

    const handleValueChange = (event) => {
        const newValue = event.target.type === 'checkbox' ? event.target.checked.toString() : event.target.value;

        if (strategy.values.length > 0) {
            strategy.values[0].value = newValue;
        }
        forceUpdate(prev => prev + 1);
    };

    const title = `Strategy ${index + 1}: ${selectedType?.name || 'New'} - ${selectedAttribute?.label || ''}`;

    return (
        <ItemCard title={title} onDelete={onDelete}>
            <FormGroup>
                <StyledLabel htmlFor="strategyType">Strategy Type</StyledLabel>
                <StyledSelect
                    id="strategyType"
                    value={strategy.strategyTypeId || ''}
                    onChange={handleTypeChange}
                >
                    <option value="">Select Strategy Type</option>
                    {strategyTypes.map(type => (
                        <option key={type.id} value={type.id}>
                            {type.name}
                        </option>
                    ))}
                </StyledSelect>
            </FormGroup>

            {selectedType && (
                <FormGroup>
                    <StyledLabel htmlFor="strategyAttribute">Strategy Attribute</StyledLabel>
                    <StyledSelect
                        id="strategyAttribute"
                        value={selectedAttributeId || ''}
                        onChange={handleAttributeChange}
                    >
                        <option value="">Select Attribute</option>
                        {selectedType.attributes.map(attr => (
                            <option key={attr.id} value={attr.id}>
                                {attr.label || attr.name}
                            </option>
                        ))}
                    </StyledSelect>
                </FormGroup>
            )}

            {selectedAttribute && selectedAttribute.dataType !== 'boolean' && (
                <FormGroup>
                    <StyledLabel htmlFor="attributeValue">{selectedAttribute.label}</StyledLabel>
                    <StyledInput
                        type="text"
                        id="attributeValue"
                        value={strategy.values?.[0]?.value || ''}
                        onChange={handleValueChange}
                    />
                </FormGroup>
            )}

            <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                <CheckboxLabel>
                    <StyledCheckbox
                        type="checkbox"
                        id="globalUsers"
                        checked={strategy.globalUsers || false}
                        onChange={(e) => {
                            strategy.globalUsers = e.target.checked;
                            forceUpdate(prev => prev + 1);
                        }}
                    />
                    Apply to Global Users
                </CheckboxLabel>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
                    <FormGroup>
                        <StyledLabel htmlFor="frequencyCap">Frequency Cap</StyledLabel>
                        <StyledInput
                            type="number"
                            id="frequencyCap"
                            value={strategy.frequencyCap || ''}
                            onChange={(e) => {
                                strategy.frequencyCap = e.target.value;
                                forceUpdate(prev => prev + 1);
                            }}
                            placeholder="Enter frequency cap"
                        />
                    </FormGroup>

                    <FormGroup>
                        <StyledLabel htmlFor="impressionLimit">Impression Limit</StyledLabel>
                        <StyledInput
                            type="number"
                            id="impressionLimit"
                            value={strategy.impressionLimit || ''}
                            onChange={(e) => {
                                strategy.impressionLimit = e.target.value;
                                forceUpdate(prev => prev + 1);
                            }}
                            placeholder="Enter impression limit"
                        />
                    </FormGroup>
                </div>
            </div>
        </ItemCard>
    );
};

export default StrategyComponent;

const CheckboxLabel = styled.label`
    display: inline-flex;
    align-items: center;
    font-size: 0.95rem;
    color: #374151;
    cursor: pointer;
    font-weight: 500;
`;
